/**
 * Application configuration settings
 */
const config = {
  // API endpoint for the backend
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:8000/api',
  
  // Current environment (development, test, production)
  env: process.env.REACT_APP_ENV || 'development',
  
  // App version
  version: process.env.REACT_APP_VERSION || '0.1.0',
  
  // Feature flags
  features: {
    enableDocumentUpload: true,
    enableLiveVerification: process.env.REACT_APP_ENABLE_LIVE_VERIFICATION === 'true',
    enableRiskScoring: process.env.REACT_APP_ENABLE_RISK_SCORING === 'true',
  },
  
  // Application settings
  settings: {
    maxFileSize: 10 * 1024 * 1024, // 10MB in bytes
    supportedFileTypes: ['application/pdf', 'image/jpeg', 'image/png'],
    maxUploadFiles: 5,
  }
};

export default config;